module.exports = __webpack_public_path__ + "img/feature_a03.1441ecbd.svg";